
<div id="create_purchase_property_address" class="collapse show">
  <address greeting="Awesome! What is the address of the new home?"
      [address]="address"></address>
  <wizard-button-group></wizard-button-group>
</div>
